import './BookingModalBreadcrumb.scss';

export const BookingModalBreadcrumb = () => (
  <ul className="booking-modal__breadcrumb" data-testid="breadcrumbs">
    <li>
      <strong>Event date &amp; time</strong>
    </li>
    <li>Select seating</li>
    <li>Add to your experience</li>
    <li>Delivery</li>
    <li>Payment</li>
  </ul>
);
